import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { SearchBar } from './SearchBar';
import { Navigation } from './Navigation';
import { CurrentAirport } from './CurrentAirport';

interface HeaderProps {
  selectedAirport: string;
  onAirportSelect: (airportId: string) => void;
}

export function Header({ selectedAirport, onAirportSelect }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="relative z-50">
      {/* Gradient background with glass effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-800/95 to-slate-900/95 backdrop-blur-xl"></div>
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=2000')] bg-cover bg-center opacity-10"></div>
      
      <div className="relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Mobile Header */}
          <div className="lg:hidden">
            <div className="flex items-center justify-between h-14 sm:h-16">
              <Logo />
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="p-2 rounded-xl text-white/80 hover:text-white hover:bg-white/10 transition-all duration-200 z-50 relative"
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
              </button>
            </div>
            {/* Mobile Search - Always visible */}
            <div className="pb-3 sm:pb-4">
              <SearchBar
                selectedAirport={selectedAirport}
                onAirportSelect={onAirportSelect}
              />
            </div>
          </div>

          {/* Desktop Header */}
          <div className="hidden lg:flex items-center justify-between py-3 sm:py-4">
            <Logo />
            <div className="flex-1 flex justify-center mx-8">
              <SearchBar
                selectedAirport={selectedAirport}
                onAirportSelect={onAirportSelect}
              />
            </div>
            <Navigation />
          </div>
        </div>

        {/* Mobile Menu - Fixed positioning to ensure visibility */}
        {isMenuOpen && (
          <div className="lg:hidden fixed inset-0 z-40 top-[56px] sm:top-[64px]">
            {/* Backdrop */}
            <div 
              className="absolute inset-0 bg-black/50 backdrop-blur-sm"
              onClick={() => setIsMenuOpen(false)}
            />
            
            {/* Menu Content - Properly positioned */}
            <div className="relative bg-slate-900/98 backdrop-blur-xl border-b border-white/10 min-h-screen">
              <div className="px-4 py-6 safe-area-inset">
                <Navigation onItemClick={() => setIsMenuOpen(false)} />
              </div>
            </div>
          </div>
        )}
      </div>
      
      <CurrentAirport selectedAirport={selectedAirport} />
    </header>
  );
}